import { IIconProps } from '../../types/IconProps.interface'

export const IconShoppingBagX = ({ color = 'white' }: IIconProps) => {
  return (
    <svg
      className='w-full'
      fill='none'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0 0h24v24H0z' fill='none' stroke='none' />
      <path d='M13 21h-4.426a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.506 3.287' />
      <path d='M9 11v-5a3 3 0 0 1 6 0v5' />
      <path d='M22 22l-5 -5' />
      <path d='M17 22l5 -5' />
    </svg>
  )
}
